import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Check } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Registrati() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [nome, setNome] = useState("");
  const [citta, setCitta] = useState("");
  const [referente, setReferente] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);

  useEffect(() => { document.title = "Crea il tuo menu | Tavoline"; }, []);

  const submit = async () => {
    setBusy(true); setError(null);
    try {
      const res = await api.register({ nome_locale: nome.trim(), citta: citta.trim(), email: email.trim(), password, referente: referente.trim() });
      setDone(res);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  const enter = async () => {
    setBusy(true); setError(null);
    try {
      await api.verifyEmail(done.verify_token);
      await login(email.trim(), password);
      navigate("/onboarding");
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div style={{ minHeight: "100vh", background: colors.paper, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: spacing.xl, gap: spacing.md, textAlign: "center" }}>
        <div style={{ width: 84, height: 84, borderRadius: 42, background: colors.success, display: "flex", alignItems: "center", justifyContent: "center" }}><Check size={40} color={colors.onAccent} /></div>
        <div style={{ ...type.serif, fontSize: 26, color: colors.ink }}>Ci sei quasi</div>
        <p style={{ ...type.sans, fontSize: 14, color: colors.inkSoft, lineHeight: "21px", maxWidth: 420 }}>Abbiamo creato il tuo locale nel piano gratuito. Ti abbiamo inviato una email di benvenuto. Configuriamo il menu insieme, bastano 2 minuti.</p>
        {error ? <div style={errStyle}>{error}</div> : null}
        <button data-testid="reg-verify" onClick={enter} disabled={busy} style={{ ...ctaStyle, marginTop: spacing.sm, minWidth: 220 }}>{busy ? "…" : "Iniziamo"}</button>
        <div style={{ ...type.sans, fontSize: 12, color: colors.inkFaint }}>Locale: {done.slug}</div>
      </div>
    );
  }

  const invalid = !nome.trim() || !email.trim() || password.length < 6;

  return (
    <div style={{ minHeight: "100vh", background: colors.paper }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: `${spacing.md}px ${spacing.lg}px`, maxWidth: 560, margin: "0 auto" }}>
        <button data-testid="back-button" onClick={() => navigate(-1)} style={iconBtn}><ChevronLeft size={26} color={colors.ink} /></button>
        <div style={{ ...type.serif, fontSize: 22, color: colors.ink }}>Crea il tuo menu</div>
        <div style={{ width: 26 }} />
      </div>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: spacing.lg, display: "flex", flexDirection: "column", gap: spacing.md }}>
        <div style={{ ...type.serif, fontSize: 34, color: colors.ink, textAlign: "center" }}>Tavoline</div>
        <div style={{ ...type.serifItalic, fontSize: 18, color: colors.ink, textAlign: "center", lineHeight: "24px" }}>Non un menu digitale.<br />Un menu che prende le comande.</div>
        <p style={{ ...type.sans, fontSize: 14, color: colors.inkSoft, lineHeight: "21px", textAlign: "center", margin: 0 }}>Gratis, senza carta di credito. Il menu online è tuo per sempre.</p>
        <F label="Nome del locale" v={nome} on={setNome} id="reg-nome" />
        <F label="Città" v={citta} on={setCitta} id="reg-citta" />
        <F label="Nome referente" v={referente} on={setReferente} id="reg-referente" />
        <F label="Email" v={email} on={setEmail} id="reg-email" type="email" />
        <F label="Password (min 6)" v={password} on={setPassword} id="reg-password" type="password" />
        {error ? <div style={errStyle}>{error}</div> : null}
        <button data-testid="reg-submit" onClick={submit} disabled={busy || invalid} style={{ ...ctaStyle, opacity: invalid ? 0.4 : 1 }}>{busy ? "…" : "Crea il locale gratis"}</button>
      </div>
    </div>
  );
}

function F({ label, v, on, id, type: t }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ ...type.sansMedium, fontSize: 13, color: colors.ink }}>{label}</label>
      <input data-testid={id} value={v} onChange={(e) => on(e.target.value)} type={t || "text"} autoCapitalize={t === "email" ? "none" : undefined} style={inputStyle} />
    </div>
  );
}

const inputStyle = { background: colors.surface, border: `1px solid ${colors.rule}`, borderRadius: radius.md, height: 50, padding: `0 ${spacing.md}px`, ...type.sans, fontSize: 15, color: colors.ink };
const ctaStyle = { background: colors.accent, height: 54, border: "none", borderRadius: radius.md, color: colors.onAccent, ...type.sansBold, fontSize: 16 };
const errStyle = { ...type.sansMedium, fontSize: 13, color: colors.danger };
const iconBtn = { background: "none", border: "none", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 };
